import { gql, TypedDocumentNode } from '@apollo/client'
import { ImageSlider } from '../type/image-slider'
import { Banner, BannerCreateInput, BannerUpdateInput } from '../type/website-settings'

export const GetImageSlider: TypedDocumentNode<{adminWebsiteSettings: {imageSlider: ImageSlider[]}}> = gql`
    query GetImageSlider {
        adminWebsiteSettings {
            imageSlider {
                fileName
                priority
            }
        }
    }
`

export const GetSecondImageSlider: TypedDocumentNode<{adminWebsiteSettings: {secondImageSlider: ImageSlider[]}}> = gql`
    query GetSecondImageSlider {
        adminWebsiteSettings {
            secondImageSlider {
                fileName
                priority
            }
        }
    }
`

export const UpdateImageSlider: TypedDocumentNode<void, {input: Omit<ImageSlider, 'key'>[]}> = gql`
    mutation UpdateImageSlider($input: [AdminWebsiteSettingsImageSliderInput!]!) {
        adminWebsiteSettingsUpdateImageSlider(input: $input) 
    }
`

export const UpdateSecondImageSlider: TypedDocumentNode<void, {input: Omit<ImageSlider, 'key'>[]}> = gql`
    mutation UpdateSecondImageSlider($input: [AdminWebsiteSettingsImageSliderInput!]!) {
        adminWebsiteSettingsUpdateSecondImageSlider(input: $input)
    }
`

export const GetBanners: TypedDocumentNode<{adminWebsiteSettings: {banners: Banner[]}}> = gql`
    query GetBanners {
        adminWebsiteSettings {
            banners {
                id
                name
                value
                location
                priority
            }
        }
    }
`

export const CreateBanner: TypedDocumentNode<void, {input: BannerCreateInput}> = gql`
    mutation CreateBanner($input: AdminWebsiteSettingsCreateBannerInput!) {
        adminWebsiteSettingsCreateBanner(input: $input)
    }
`


export const UpdateBanner: TypedDocumentNode<void, {input: BannerUpdateInput}> = gql`
    mutation UpdateBanner($input: AdminWebsiteSettingsUpdateBannerInput!) {
        adminWebsiteSettingsUpdateBanner(input: $input)
    }
`

export const DeleteBanner: TypedDocumentNode<void, {input: {id: number}}> = gql`
    mutation DeleteBanner($input: AdminWebsiteSettingsDeleteBannerInput!) {
        adminWebsiteSettingsDeleteBanner(input: $input)
    }
`

export const UpdateBannerPriority: TypedDocumentNode<void, {input: {id: number, priority: number}[]}> = gql`
    mutation UpdateBannerPriority($input: [AdminWebsiteSettingsUpdateBannerPriorityInput!]!) {
        adminWebsiteSettingsUpdateBannerPriority(input: $input)
    }
`
